var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "pa-0": "" } },
    [
      _c(
        "v-row",
        {
          staticStyle: { height: "100vh" },
          attrs: { align: "center", justify: "center", dense: "" },
        },
        [
          _c(
            "v-col",
            {
              staticClass:
                "fill-height d-flex flex-column justify-center align-center",
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "", "max-width": "975px" } },
                [
                  _c("v-row"),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c("img", {
                            attrs: {
                              width: "145",
                              height: "50",
                              src: "/content/images/TheStudio_Logo_Lockup-Stacked_Dark.svg",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.keyMissing
                    ? _c(
                        "v-card",
                        {
                          attrs: {
                            flat: "",
                            "max-width": "350px",
                            "min-width": "350px",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "toastify-container",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm.success
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "span",
                                                  { staticClass: "forgot-lbl" },
                                                  [
                                                    _vm._v(
                                                      "Your password is ready!"
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n4" },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "forgot-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "You can login to your account with the new password now."
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-6" },
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "white--text entity-button-text",
                                                      attrs: {
                                                        color: "secondary",
                                                      },
                                                      on: {
                                                        click: _vm.openLogin,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Return to Login\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.dbKeyIsMissing
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "span",
                                                  { staticClass: "forgot-lbl" },
                                                  [
                                                    _vm._v(
                                                      "Password link has already been used."
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n4" },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "forgot-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Please use 'Forgot Password' to create a new password"
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-6" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "5" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "white--text entity-button-text",
                                                      attrs: {
                                                        color: "secondary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.resetPassword,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Forgot Password\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    align: "center",
                                                    cols: "2",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "forgot-desc",
                                                    },
                                                    [_vm._v("OR")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "5" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "white--text entity-button-text",
                                                      attrs: {
                                                        outlined: "",
                                                        color: "secondary",
                                                      },
                                                      on: {
                                                        click: _vm.openLogin,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Return to Login\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.success && !_vm.dbKeyIsMissing
                                    ? _c(
                                        "span",
                                        { staticClass: "forgot-lbl" },
                                        [
                                          _vm._v(
                                            "Enter your new password below."
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.success && !_vm.dbKeyIsMissing
                                    ? _c(
                                        "form",
                                        {
                                          attrs: { name: "form", role: "form" },
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                              return _vm.finishReset()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { align: "start" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-label left",
                                                    },
                                                    [_vm._v("Create Password")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n6" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { align: "start" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      id: "newPassword",
                                                      name: "newPassword",
                                                      type: "password",
                                                      rules:
                                                        _vm.setPasswordRules(),
                                                      "append-icon": _vm.hidden
                                                        ? "visibility"
                                                        : "visibility_off",
                                                      type: _vm.hidden
                                                        ? "password"
                                                        : "text",
                                                      dense: "",
                                                      outlined: "",
                                                    },
                                                    on: {
                                                      "click:append": () =>
                                                        (_vm.hidden =
                                                          !_vm.hidden),
                                                      input: function ($event) {
                                                        return _vm.validate()
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.resetAccount
                                                          .newPassword,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.resetAccount,
                                                          "newPassword",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "resetAccount.newPassword",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n8 ml-1" },
                                            [
                                              _c(
                                                "v-card",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    "max-width": "350px",
                                                    "min-width": "350px",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.uiOptions,
                                                  function (item, i) {
                                                    return _c(
                                                      "div",
                                                      { key: i },
                                                      [
                                                        item.name === "minLen"
                                                          ? _c(
                                                              "v-row",
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    item.valid
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "green",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "#6B7280",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-circle-small"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "10",
                                                                      align:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "small",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.value
                                                                              ) +
                                                                                " characters"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.name ===
                                                        "numerical"
                                                          ? _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "mt-n8",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    item.valid
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "green",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "#6B7280",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-circle-small"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "10",
                                                                      align:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "small",
                                                                          [
                                                                            _vm._v(
                                                                              "One number"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.name ===
                                                        "upperLower"
                                                          ? _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "mt-n8",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    item.valid
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "green",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "#6B7280",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-circle-small"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "10",
                                                                      align:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "small",
                                                                          [
                                                                            _vm._v(
                                                                              "At least one upper and lower case letter"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.name ===
                                                        "blacklist"
                                                          ? _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "mt-n8",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    item.valid
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "green",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "#6B7280",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-circle-small"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "10",
                                                                      align:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "small",
                                                                          [
                                                                            _vm._v(
                                                                              "No common words"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.name ===
                                                        "personalInfo"
                                                          ? _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "mt-n8",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "1",
                                                                    },
                                                                  },
                                                                  [
                                                                    item.valid
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "green",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                color:
                                                                                  "#6B7280",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-close"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "10",
                                                                      align:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "small",
                                                                          [
                                                                            _vm._v(
                                                                              "No personal information"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { align: "start" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-label left",
                                                    },
                                                    [_vm._v("Confirm Password")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n6" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { align: "start" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      id: "confirmPassword",
                                                      name: "confirmPassword",
                                                      type: "password",
                                                      rules:
                                                        _vm.setRepeatPasswordRules(),
                                                      "append-icon":
                                                        _vm.hiddenConfirm
                                                          ? "visibility"
                                                          : "visibility_off",
                                                      type: _vm.hiddenConfirm
                                                        ? "password"
                                                        : "text",
                                                      dense: "",
                                                      outlined: "",
                                                    },
                                                    on: {
                                                      "click:append": () =>
                                                        (_vm.hiddenConfirm =
                                                          !_vm.hiddenConfirm),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.resetAccount
                                                          .confirmPassword,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.resetAccount,
                                                          "confirmPassword",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "resetAccount.confirmPassword",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                justify: "space-around",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { align: "start" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "white--text entity-button-text left",
                                                      attrs: {
                                                        color: "secondary",
                                                        disabled:
                                                          _vm.$v.resetAccount
                                                            .$invalid,
                                                        type: "submit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Submit\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-row", { staticClass: "mt-8" }, [
                                            _vm._v(" "),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pageHeight > 685
                ? _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "footer-policy",
                                      style: _vm.isMobile
                                        ? "width: 72%; left:13%"
                                        : "left:9%; width: 31%",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "footer-policy-txt" },
                                        [
                                          _vm._v(
                                            "Unless otherwise agreed upon in writing, use of this software is subject to the ELB Learning Subscription and "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#1D4ED8" },
                                              attrs: {
                                                href: "https://www.elblearning.com/subscription-and-license-agreement",
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("License Agreement")]
                                          ),
                                          _vm._v(" and "),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#1D4ED8" },
                                              attrs: {
                                                href: "https://www.elblearning.com/privacy-policy",
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("Privacy Policy")]
                                          ),
                                          _vm._v("."),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "footer-copy",
                                      style: _vm.isMobile
                                        ? "width: 72%; left:13%"
                                        : "left:9%; width: 31%",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "© " +
                                            _vm._s(_vm.year) +
                                            " ELB Learning. All rights reserved."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass:
                "justify-center align-center shrink hidden-sm-and-down",
              staticStyle: { padding: "0px" },
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c("v-img", {
                attrs: {
                  height: "100vh",
                  src: "/content/images/LoginScreen_BG-image.webp",
                },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-logo",
                attrs: { src: "/content/images/ELB-Learning_Logo_White.svg" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }